import { all } from 'redux-saga/effects';

import consultaInteracoes from './consultaInteracoes/reducer';
import enviaInteracoes from './enviaInteracoes/reducer';
import enviaRespostas from './enviaRespostas/reducer';

export default all([consultaInteracoes, enviaInteracoes, enviaRespostas]);
